/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { TOOLTIP_ACTIONS } from './constants.js';

var HOVER_START = TOOLTIP_ACTIONS.HOVER_START,
  HOVER_END = TOOLTIP_ACTIONS.HOVER_END,
  FOCUS_START = TOOLTIP_ACTIONS.FOCUS_START,
  FOCUS_END = TOOLTIP_ACTIONS.FOCUS_END,
  CLICK_TOGGLE = TOOLTIP_ACTIONS.CLICK_TOGGLE,
  CLICK_OUTSIDE = TOOLTIP_ACTIONS.CLICK_OUTSIDE,
  PRESS_ESCAPE = TOOLTIP_ACTIONS.PRESS_ESCAPE,
  DEFERRED_CLOSE = TOOLTIP_ACTIONS.DEFERRED_CLOSE;
function hoverReducer(state, _ref) {
  var type = _ref.type;
  switch (type) {
    // focus and hover now open the tooltip, rather than having their own state
    case FOCUS_START:
    case HOVER_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: true,
        deferredClose: false
      });
    // using hover behaviour, toggle still toggles
    case CLICK_TOGGLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: !state.showTooltip,
        deferredClose: false
      });
    // all other interactions will close the tooltip
    case FOCUS_END:
    case CLICK_OUTSIDE:
    case PRESS_ESCAPE:
    case DEFERRED_CLOSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: false,
        deferredClose: false
      });
    case HOVER_END:
      return _objectSpread(_objectSpread({}, state), {}, {
        showTooltip: false,
        deferredClose: true
      });
    // istanbul ignore next
    default:
      return state;
  }
}

export { hoverReducer as default };
